// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1InvoiceRulesUpdateSchema = z.object({
  invoice_rules: z.object({
    invoice_method: z.coerce.string().describe("Invoice method (manual or automatic)").nullish(),
    standard_invoice_date: z.coerce.string().describe("Standard invoice date (first_of_month or last_of_month)").nullish(),
    invoice_by: z.coerce.string().describe("Invoice grouping (client or project)").nullish(),
    list_item_grouping: z.coerce.string().describe("Line item grouping method").nullish(),
  }),
});
